import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import dotsIcon from 'assets/images/icons/table-icons.svg';
import dropdownIcon from 'assets/images/icons/dropdown-arrow-white.svg';
import FormButton from 'components/form-components/FormButton';
import MultiLevelSelect from 'components/form-components/MultiLevelSelect';
import AlertModal from 'components/common-components/AlertModal';
import { isPermissionAvailable } from 'config/permissionUtils';
import { permissionKeys } from 'config/config';

const GuestUsersActions = ({ ids, actionsCallBack, isActionButton }) => {
  const { t } = useTranslation();

  const [actionsOptions, setActionsOptions] = useState([]);
  const [confirmModalProps, setConfirmModalProps] = useState(null);

  useEffect(() => {
    const allOptions = [
      {
        value: 'edit',
        displayValue: 'select_edit',
        permission: isPermissionAvailable(permissionKeys.employees_users_create),
      },
      {
        value: 'delete',
        displayValue: 'select_delete',
        permission: isPermissionAvailable(permissionKeys.employees_users_delete),
      },
    ];

    const visibleOptions = allOptions.filter((option) => option.permission);

    setActionsOptions(visibleOptions);
  }, []);

  const handleAction = (_, value) => {
    if (value === 'edit') actionsCallBack(value, { ids });
    else if (value === 'delete') {
      setConfirmModalProps({
        type: value,
        message: 'alert_delete_user',
        text: 'button_delete',
      });
    }
  };

  const handleConfirmAction = () => {
    if (confirmModalProps.type === 'delete')
      actionsCallBack(confirmModalProps.type, { ids: ids.map((i) => i.id) });

    setConfirmModalProps(null);
  };

  return (
    <>
      {confirmModalProps && (
        <AlertModal
          show={true}
          showCloseButton={true}
          closeModal={() => setConfirmModalProps(null)}
          variant='delete'
          message={t(confirmModalProps.message)}
          actionButtons={[
            {
              text: t('button_cancel'),
              variant: 'white-1',
              onClick: () => {
                setConfirmModalProps(null);
              },
            },
            {
              text: t(confirmModalProps.text),
              variant: 'red-1',
              onClick: () => {
                handleConfirmAction();
              },
            },
          ]}
        />
      )}

      <MultiLevelSelect
        options={{ children: actionsOptions }}
        value={[]}
        name='action'
        handleChange={(name, value) => handleAction(name, value[0])}
        toggleClasses=''
        toggleComponent={
          <>
            {isActionButton ? (
              <img className='cursor-pointer' src={dotsIcon} />
            ) : (
              <FormButton text='button_action' variant='green-1' icon={dropdownIcon} minWidth />
            )}
          </>
        }
        disabled={!ids.length || !actionsOptions.length}
      />
    </>
  );
};

GuestUsersActions.propTypes = {
  ids: PropTypes.array.isRequired,
  actionsCallBack: PropTypes.func.isRequired,
  isActionButton: PropTypes.bool.isRequired,
};

export default GuestUsersActions;
